module.exports = __webpack_public_path__ + "img/share_tip.16d6f72a.png";